import React from 'react';
import Scanner from './components/scanner';
import InsertSeriale from './components/insertSeriale';
import "./index.css"

function App() {
  return (
    <div className='flex items-center justify-center min-h-screen'>
      <div className='backdrop-blur-xs bg-white/75 p-6 sm:p-8 md:p-10 rounded-[15px] border border-black/25 font-medium w-full max-w-lg'>
        <Scanner />
        <InsertSeriale />
      </div>
    </div>
  );
}

export default App;
